import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import type {RawCapacity} from '@/components/Capacity/CapacityList';
import {mapRawCapacityDefault} from '@/components/Capacity/CapacityList';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityDefault} from '@/types/CapacityDefault';
import type {Employee} from '@/types/Employee';
import {apiUrl} from '@/utils/api';

type Props = {
    employees : Employee[];
};

export const useGetCapacityDefaults = (props : Props) : UseQueryResult<CapacityDefault[]> => {
    const fetch = useApiFetch();

    return useQuery(['capacityDefaults'], async ({signal}) => {
        const response = await fetch(
            apiUrl('/v1/capacity/capacity/defaults').toString(),
            {
                method: 'POST',
                body: JSON.stringify({
                    associateIDs: props.employees.map(employee => employee.id.toString()),
                }),
                signal,
            }
        );

        if (!response.ok) {
            throw new Error('Unable to fetch capacity defaults.');
        }

        const data = await response.json() as RawCapacity[];
        return data.map(raw => mapRawCapacityDefault(raw));
    });
};
